import { createFileRoute } from "@tanstack/react-router";
import { TruthComparePage } from "@client/components/truth/truth-compare-page";

export const Route = createFileRoute("/_app/truth/compares")({
  component: TruthComparePage,
});
